import styled from 'styled-components';
import { academyCustomCSS } from '~/constants/academyCustomCSS';
import academyStyles from './academy-styles';

export default function AcademyThemeCardWrapper({ children }) {
  return (
    <AcademyThemeCards className={`${academyCustomCSS.cardList.cardsContainer} academy-cards-wrapper`}>
      {children}
    </AcademyThemeCards>
  );
}

const AcademyThemeCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;
  ${academyStyles.mediaQueries.collapseToTwoColumnsAt} {
    max-width: ${academyStyles.mediaQueries.twoColumnMaxWidth};
  }
  ${academyStyles.mediaQueries.collapseToOneColumnAt} {
    max-width: ${academyStyles.mediaQueries.oneColumnMaxWidth};
  }

  &:after {
    content: '';
    width: ${academyStyles.card.cardWidth}px;
  }
`;
